module.exports = __webpack_public_path__ + "static/wiczlino6-5468d9473ccf1723fe55a053f440fca5.jpg";